<template>
    <div>
        <!-- Breadcrumb Section Start -->
        <section class="breadscrumb-section pt-0">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="breadscrumb-contain">
                            <h2>{{ $t('Gifts') }}</h2>
                            <nav>
                                <ol class="breadcrumb mb-0">

<!--                                    <li class="breadcrumb-item active" aria-current="page">-->
<!--                                        Shop Right Sidebar-->
<!--                                    </li>-->

                                    <li class="breadcrumb-item">
                                        <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                            <i class="fa-solid fa-house"></i>
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Breadcrumb Section End -->

        <!-- Shop Section Start -->
        <section class="section-b-space shop-section">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-custome-3 wow fadeInUp">
                        <div class="left-box">
                            <div class="shop-left-sidebar">
                                <div class="back-button">
                                    <h3>
                                        <i class="fa-solid fa-arrow-left"></i> {{ $t('Back') }}
                                    </h3>
                                </div>

                                <div class="accordion custome-accordion" id="accordionExample">

                                    <div class="accordion-item">
                                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                                            <div class="accordion-body">
                                                <div class="form-floating theme-form-floating-2 ">
                                                    <input type="search" class="form-control" id="search"
                                                           :placeholder="$t('input_search')" v-debounce:400ms="setName" :value="q.name">
                                                    <label for="search">{{ $t('Gift name') }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="panelsStayOpen-section">
                                            <button class="accordion-button" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseSection"
                                                    aria-expanded="true" aria-controls="collapseSection">
                                                <span>{{ $t('By section') }}</span>
                                            </button>
                                        </h2>
                                        <div id="collapseSection" class="accordion-collapse collapse show"
                                             aria-labelledby="panelsStayOpen-section">
                                            <div class="accordion-body">
                                                <ul class="category-list custom-padding">
                                                    <li  v-for="section in main?.sections">
                                                        <div class="form-check ps-0 m-0 section">
                                                            <input class="checkbox_animated" type="checkbox"
                                                                   v-model="q.section_ids" :value="section.id" :id="'section-' + section.id">
                                                            <label class="form-check-label" :for="'section-' + section.id">
                                                                <span class="name">
                                                                    <img v-if="section.icon != null" :src="section.icon" width="23" />
                                                                    {{ section?.name }}
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="panelsStayOpen-category">
                                            <button class="accordion-button" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseCategory"
                                                    aria-expanded="true" aria-controls="collapseCategory">
                                                <span>{{ $t('By category') }}</span>
                                            </button>
                                        </h2>
                                        <div id="collapseCategory" class="accordion-collapse collapse show"
                                             aria-labelledby="panelsStayOpen-category">
                                            <div class="accordion-body">
                                                <ul class="category-list custom-padding">
                                                    <li  v-for="category in main?.categories">
                                                        <div class="form-check ps-0 m-0 category-list-box">
                                                            <input class="checkbox_animated" type="checkbox"
                                                                   v-model="q.category_ids" :value="category.id" :id="'category-' + category.id">
                                                            <label class="form-check-label" :for="'category-' + category.id">
                                                                <span class="name">
                                                                    <img v-if="category.icon != null" :src="category.icon" width="23" />
                                                                    {{ category?.name }}
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="accordion-item" v-if="main?.occasions?.length > 0 ">
                                        <h2 class="accordion-header" id="panelsStayOpen-headingOccasion">
                                            <button class="accordion-button" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseOccasion"
                                                    aria-expanded="true" aria-controls="collapseOccasion">
                                                <span>{{ $t('By occasion') }}</span>
                                            </button>
                                        </h2>
                                        <div id="collapseOccasion" class="accordion-collapse collapse show"
                                             aria-labelledby="panelsStayOpen-headingOccasion">
                                            <div class="accordion-body">
                                                <ul class="category-list custom-padding">
                                                    <li  v-for="occasion in main?.occasions">
                                                        <div class="form-check ps-0 m-0 category-list-box">
                                                            <input class="checkbox_animated" type="checkbox"
                                                                   v-model="q.occasion_ids" :value="occasion.id" :id="'occasion-' + occasion.id">
                                                            <label class="form-check-label" :for="'occasion-' + occasion.id">
                                                                <span class="name">
                                                                    <img v-if="occasion.icon != null" :src="occasion.icon" width="23" />
                                                                    {{ occasion?.name }}
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="panelsStayOpen-store">
                                            <button class="accordion-button" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseStore"
                                                    aria-expanded="true" aria-controls="collapseStore">
                                                <span>{{ $t('By store') }}</span>
                                            </button>
                                        </h2>
                                        <div id="collapseStore" class="accordion-collapse collapse show"
                                             aria-labelledby="panelsStayOpen-store">
                                            <div class="accordion-body">
                                                <ul class="category-list custom-padding">
                                                    <li  v-for="vendor in main?.all_vendors">
                                                        <div class="form-check ps-0 m-0 category-list-box">
                                                            <input class="checkbox_animated" type="checkbox"
                                                                   v-model="q.vendor_ids" :value="vendor.id" :id="'store-' + vendor.id">
                                                            <label class="form-check-label" :for="'store-' + vendor.id">
                                                                <span class="name">
                                                                    <img v-if="vendor.avatar != null" :src="vendor.avatar" width="23" />
                                                                    {{ vendor?.name }}
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                                            <button class="accordion-button" type="button"
                                                    data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                    aria-expanded="true" aria-controls="collapseThree">
                                                <span>{{ $t('Price')}}</span>
                                            </button>
                                        </h2>
                                        <div id="collapseThree" class="accordion-collapse collapse show"
                                             aria-labelledby="panelsStayOpen-headingThree">
                                            <div class="accordion-body">
                                                <div class="d-flex ">
                                                    <div class="d-flex me-1 ">
                                                        <label class="input-group-text border-0 px-1 bg-transparent" for="price-from">
                                                            {{ $t('From') }}
                                                        </label>
                                                        <input class="form-control " type="number" id="price-from" @input="onPriceInput()" v-model="this.q_price.from">
                                                        <label class="input-group-text  px-1 border-0 bg-transparent" for="price-to">
                                                            {{ $t('To') }}
                                                        </label>
                                                        <input class="form-control " type="number" id="price-to" @input="onPriceInput()" v-model="this.q_price.to">
                                                    </div>
                                                    <!--                                        <a class="btn btn-sm btn-link" @click="q.price = q_price">عرض</a>-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-custome-9 wow fadeInUp">
                        <div class="show-button">

                            <div class="top-filter-menu mt-0 w-100  d-flex  justify-content-between">
                                <div class="category-dropdown">
                                    <h5 class="text-content text-content pt-1">{{ $t('Sort by') }} :</h5>
                                    <div class="dropdown">
                                        <select class="form-select" aria-label="" v-model="q.order">
                                            <option :value="null" selected>
                                                {{ $t('Featured') }}
                                            </option>
                                            <option :value="{'by' : 'price' , 'direction' : 'DESC' , }">
                                                {{ $t('Price high to low') }}
                                            </option>
                                            <option :value="{'by' : 'price' , 'direction' : 'ASC' , }">
                                                {{ $t('Price low to high') }}
                                            </option>
                                        </select>
                                    </div>
                                </div>


<!--                                <div class="category-dropdown">-->
<!--                                    <h5 class="text-content">{{ $t('Sort by') }} :</h5>-->
<!--                                    <div class="dropdown">-->
<!--                                        <button class="dropdown-toggle" type="button" id="dropdownMenuButton1"-->
<!--                                                data-bs-toggle="dropdown">-->
<!--                                            <span> </span> <i class="fa-solid fa-angle-down"></i>-->
<!--                                        </button>-->
<!--                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">-->
<!--                                            <li>-->
<!--                                                <a class="dropdown-item" id="pop"-->
<!--                                                   href="javascript:void(0)"  @click="q.order = null">-->
<!--                                                    الخيارات المميزة-->
<!--                                                </a>-->
<!--                                            </li>-->
<!--                                            <li>-->
<!--                                                <a class="dropdown-item" id="low"-->
<!--                                                   href="javascript:void(0)" @click="q.order = {'by' : 'price' , 'direction' : 'DESC' , }">-->
<!--                                                    السعر الأعلى أولاً-->
<!--                                                </a>-->
<!--                                            </li>-->
<!--                                            <li>-->
<!--                                                <a class="dropdown-item" id="low"-->
<!--                                                   href="javascript:void(0)" @click="q.order = {'by' : 'price' , 'direction' : 'ASC' , }">-->
<!--                                                    السعر الأقل أولاً-->
<!--                                                </a>-->
<!--                                            </li>-->
<!--                                        </ul>-->
<!--                                    </div>-->
<!--                                </div>-->



                                <div class="filter-button-group mt-0">
                                    <div class="filter-button d-inline-block d-lg-none">
                                        <a>
                                            <i class="fa-solid fa-filter"></i>
<!--                                            {{ $t('Filter Menu')}}-->
                                        </a>
                                    </div>
                                </div>

                                <div class="grid-option d-none d-md-block">
                                    <ul>
                                        <li class="three-grid">
                                            <a href="javascript:void(0)">
                                                <img src="/theme/assets/svg/grid-3.svg" class="blur-up lazyload" alt="">
                                            </a>
                                        </li>
                                        <li class="grid-btn d-xxl-inline-block d-none active">
                                            <a href="javascript:void(0)">
                                                <img src="/theme/assets/svg/grid-4.svg"
                                                     class="blur-up lazyload d-lg-inline-block d-none" alt="">
                                                <img src="/theme/assets/svg/grid.svg"
                                                     class="blur-up lazyload img-fluid d-lg-none d-inline-block" alt="">
                                            </a>
                                        </li>
                                        <li class="list-btn">
                                            <a href="javascript:void(0)">
                                                <img src="/theme/assets/svg/list.svg" class="blur-up lazyload" alt="">
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div
                            class="row g-sm-4 g-3 row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2 product-list-section">
                            <div v-for="product in items?.data" :key="product.id" >
                                <div class="product-box-3 h-100 wow fadeInUp">
                                    <div class="product-header">
                                        <div class="product-image">
                                            <router-link :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">
                                                <img :src="product.image ?? '/theme/assets/images/more/gift-card.png'"
                                                     class="img-fluid blur-up lazyload" alt="">
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="product-footer">
                                        <div class="product-detail">

                                            <div class=" overflow-hidden  mb-2" v-if="product?.occasions?.length > 0 ">
                                            <div class=" d-flex justify-content-start overflow-x-auto" v-if="product?.occasions?.length > 0 ">

                                                <div class=" p-1"  v-for="occasion in product?.occasions">
                                                    <img :src="occasion?.icon" :alt="occasion?.name"
                                                         class=" border p-1 rounded-circle"
                                                         data-bs-toggle="tooltip" data-bs-placement="top" :title="occasion?.name"
                                                         height="25" width="25">
                                                </div>

                                            </div>
                                            </div>

                                            <router-link :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">
                                                <h5 class="name  mb-2"> {{ product?.name }} </h5>
                                            </router-link>
                                            <p class="text-content mt-1 mb-2 product-content">
                                                {{ product?.description}}
                                            </p>
                                            <h5 class="d-flex justify-content-end"
                                                v-if="product?.prices?.length === 0">
                                                <h5 class="price">

                                                    <del class="text-content" v-if="product?.old_price != null">{{ product?.old_price }} {{ $t('SAR') }}</del>

                                                    <span class="theme-color">{{ product?.price_tax }} {{ $t('SAR') }}</span>


<!--                                                    <span class="offer theme-color" v-if="product?.discount !== null">({{ product?.discount }}% تخفيض)</span>-->

                                                </h5>
                                            </h5>
                                            <CartButton :product="product" :type="'box'"></CartButton>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <Bootstrap5Pagination
                            class="m-2"
                            :data="items"
                            :limit="2"
                            :show-disabled="false"
                            :size="'default'"
                            :align="'center'"
                            @pagination-change-page="pagination"
                        />

                    </div>
                </div>
            </div>
        </section>
        <!-- Shop Section End -->
    </div>
</template>

<script>

import { useToast } from "vue-toastification";
const toast = useToast();
import Utility from "../../utility";

import { Bootstrap5Pagination } from 'laravel-vue-pagination'
import CartButton from "../cart_item/CartButton.vue";
export default {
    props: ['main'],
    components:{
        CartButton,
        Bootstrap5Pagination
    },
    watch: {
        'q': { // Auto search
            handler: function(newValue) {

                let form_params = Utility.convertModelToFormData(newValue);
                // if(this.isCreated == true){
                //     form_params.append('page', 1);
                // }

                this.$router.replace({
                    name: "products.index",
                    query: Object.fromEntries(form_params) , params: { lang : this.$i18n.locale }
                });

                console.log('---handler');
                // this.getResults(1,'filter');
            },
            deep: true
        },
        // '$route.query': { // Auto search
        //     handler: function(newValue,oldValue) {
        //         if(oldValue.page==newValue.page){
        //             this.getResults(1,'query');
        //         }
        //     },
        //     deep: true
        // }
    },
    data() {
        return {
            // isCreated: false,
            // getResultsOnCreate: true,
            debounceTimer: null,
            items: [],
            q_price: {
                from : null,
                to : null
            },
            q: {
                order : null,
                price : {
                    from : null,
                    to : null
                },
                section_ids : [],
                category_ids : [],
                occasion_ids : [],
                vendor_ids : [],
                quantities : {
                    from : null,
                    to : null
                },
                ...this.$route.query,
            },
            form_options: {},
        }
    },
     async created() {
         // this.isCreated = true;
         console.log('---created');
         // console.log(this.$route?.query);
         // console.log(this.$route?.query?.length);
         //
         // const numberOfQueryKeys = Object.keys(this.$route?.query || {}).length;
         // console.log(numberOfQueryKeys);

         this.removeArrayQueries(this.q);

         // if(this.getResultsOnCreate){
            await this.getResults(this.$route?.query?.page ?? 1 ,'query');
         // }

         await this.themeJs();
     },
    methods: {
        removeArrayQueries(dataObject) {
            // const that = this;
            // Function to remove array-based query parameters from the 'q' data object
            // console.log('removeArrayQueries');
            for (const key in dataObject) {
                const matches = key.match(/(\w+)\[(\d*)\]/);

                if (
                    matches !== null
                ) {

                    const new_key = matches[1];
                    // console.log(new_key);
                    // console.log(typeof dataObject[key]);

                    // push new value  to dataObject[new_key] or create new if not exists and push
                    if (Array.isArray(dataObject[new_key])) {
                        dataObject[new_key].push(dataObject[key]);
                        // this.getResultsOnCreate = false;
                    } else {
                        dataObject[new_key] = [dataObject[key]];
                        // this.getResultsOnCreate = false;
                    }
                    delete dataObject[key];
                }
            }
            return dataObject;
        },
        setName(val) {
            this.q.name = val;
        },
        themeJs() {

            (function ($) {
                "use strict";

                /*=====================
                02. Shop Page Grid Setting Js
                ==========================*/
                $(".grid-option li").on("click", function () {
                    $(this).addClass('active').siblings().removeClass('active');
                });
                $(".grid-option .grid-btn").on("click", function () {
                    $(".product-list-section").removeClass("list-style");
                });
                $(".grid-option .list-btn").on("click", function () {
                    $(".product-list-section").addClass("list-style");
                });
                $('.three-grid').on('click', function (e) {
                    $(".product-list-section").removeClass("row-cols-xxl-5 row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2 list-style").addClass("row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2");
                });
                $('.grid-btn').on('click', function (e) {
                    $(".product-list-section").removeClass("row-cols-xxl-5 row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2 list-style").addClass("row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2");
                });
                $('.five-grid').on('click', function (e) {
                    $(".product-list-section").removeClass("list-style").addClass("row-cols-xxl-5 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2");
                });
                var contentwidth = $(window).width();
                if (contentwidth < "1199") {
                    $(".grid-options ul .grid-btn").addClass("active");
                }
                if (contentwidth < "1399") {
                    $(".grid-options ul .three-grid").addClass("active");
                }
            })(jQuery);

            /**=====================
             Filter Sidebar js
             ==========================**/
            $(".filter-button").click(function () {
                console.log('---- filter-button');
                $(".bg-overlay, .left-box").addClass("show");
            });
            $(".back-button, .bg-overlay").click(function () {
                $(".bg-overlay, .left-box").removeClass("show");
            });

            $(document).ready(function () {
                $(".sort-by-button").click(function () {
                    $(".top-filter-menu").toggleClass("show");
                });
            });
        },
        onPriceInput() {
            // Clear the previous timer if exists
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            // Set up a new timer to call the handler after 500ms (adjust the time as needed)
            this.debounceTimer = setTimeout(() => {

                // Perform actions or update the filter based on the provided values
                // For example, you can emit an event to notify the parent component of the changes.
                this.q.price = {
                    'from' : this.q_price.from,
                    'to' : this.q_price.to,
                };
            }, 500); // Adjust the delay time (in milliseconds) as needed
        },
        async pagination(page) {

            let form_params = Utility.convertModelToFormData(this.q);
            form_params.append('page', page);
            this.$router.replace({
                name: "products.index",
                query: Object.fromEntries(form_params) , params: { lang : this.$i18n.locale }
            });

        },
        async getResults(page,type = 'filter') {
            console.log(page);
            console.log('getResults <---');

            const id = toast.info(this.$t('Getting content ...'), {icon: 'fa-light fa-filter-list'});
            let _params = null;
            console.log(type);
            if(type == 'query'){
                _params = {
                ...this.$route.query,
                page: page,
                };
            }else{
                _params = {
                ...this.q,
                page: page,
                };
            }
            let form_params = Utility.convertModelToFormData(this.q);
            await axios.get('products', {params: Object.fromEntries( form_params )}).then(response => {
                toast.dismiss(id);
                this.items = response.data;

                console.log('replace <---');

            }, response => {
                toast.dismiss(id);
            });

        },
    },
}
</script>
